


















import Vue from "vue";
import Component from "vue-class-component";
import { hasPermission } from "../../plugins/guard";

@Component
export default class AppInviteUser extends Vue {
  onInviteUser() {
    this.$store.commit("INVITE_USER_CLICK");
  }

  get showBtnInvite() {
    return hasPermission({ context: 'USER_MANAGEMENT', action: 'create' });
  }
}
